module.exports = __webpack_public_path__ + "static/media/Girls Like You.fea1820b.txt";